module.exports = __webpack_public_path__ + "img/qled8k.f21bf729.png";